<template>
  <div class="page">
    <div
      v-if="overdueFlag"
      class="m-warning-alert"
    >
      <i class="h-icon-tip_atten"></i>
      <span v-html="LicenseMsg.expireMsg"></span>
      <i
        class="u-btn-close h-icon-close"
        @click="overdueFlag = false"
      ></i>
    </div>
    <full-screen
      v-if="!layoutType"
      :overdueFlag="overdueFlag"
      :arrList="arrList"
    ></full-screen>
    <water-fall
      v-else
      :overdueFlag="overdueFlag"
      :arrList="arrList"
      :widthType="widthType"
    ></water-fall>
    <el-dialog
      :title="dialoData.title"
      :visible.sync="dialoData.visible"
      size="small"
    >
      <iframe
        style="width:100%;height:100%;min-height:600px;"
        :src="dialoData.url"
        frameborder="0"
      ></iframe>
    </el-dialog>
  </div>
</template>

<script>
import Api from 'api/api'
import fullScreen from './home-page-container/full-screen'
import waterFall from './home-page-container/water-fall'
import { mapActions } from 'vuex'
import { ErrorHandleMixin } from 'utils/mixin'

export default {
  components: { fullScreen, waterFall },
  name: 'home',
  data () {
    return {
      language: 'zh_CN',
      arrList: [],
      dialoData: {
        visible: false,
        title: '',
        url: ''
      },
      // 授权信息
      LicenseMsg: {},
      overdueFlag: false,
      // 首页模式：定宽-1/全屏-0
      layoutType: 0,
      // 可是窗大小
      winSize: {
        w: 0,
        h: 0
      },
      // 瀑布模式宽度类型:0-智慧连锁，1-教学
      widthType: 0
    }
  },
  created () {
  },
  mounted () {
    let app = document.getElementById('app')
    this.winSize.w = app.offsetWidth
    this.winSize.h = app.offsetHeight
    this.$nextTick(() => {
      this.getConfigList()
    })
    this._getLicenseInfo()
  },
  updated () {
    this.initEcharts()
  },
  methods: {
    // vuex
    ...mapActions(['openMenuStatic']),
    _getLicenseInfo () {
      Api.login
        .getLicenseInfo()
        .then(res => {
          this.LicenseMsg = res.data
          this.overdueFlag = !!res.data.expireMsg
        })
    },
    changeLanguage (lang) {
      this.$utils.i18n.setLanguage(lang)
    },
    // 获取首页配置信息
    getConfigList () {
      Api.home
        .list({ isBigData: false })
        .then(res => {
          this.arrList = []
          this.layoutType = res.data.layoutType
          this.widthType = res.data.widthType
          // if (!this.layoutType) {
          for (var i = 0; i < res.data.userWidgetInfos.length; i++) {
            this.arrList.push(Object.assign({}, res.data.userWidgetInfos[i]))
            this.arrList[i].refreshPeriod = this.arrList[i].refreshPeriod || 0
          }
        })
        .catch(error => {
          this.$message.error(error)
        })
    },
    homeConfig () {
      let ctn = document.getElementsByClassName('home-page')[0]
      let colsP = 1
      let rowsP = 2
      for (let i = 0; i < this.arrList.length; i++) {
        let uW = this.arrList[i].width
        let uH = this.arrList[i].height
        let xPos = this.arrList[i].xPos
        let yPos = this.arrList[i].yPos
        let tempDom = document.createElement('div')
        tempDom.style.width = uW * colsP + '%'
        tempDom.style.height = uH * rowsP + '%'
        tempDom.style.position = 'absolute'
        tempDom.style.left = xPos * colsP + '%'
        tempDom.style.top = yPos * rowsP + '%'
        tempDom.style.background = this.randomHexColor()
        ctn.appendChild(tempDom)
      }
    },
    moreOpen (item) {
      if (item.moreOpenType === 'dialog') {
        this.dialoData.visible = true
        this.dialoData.title = item.title
        this.dialoData.url = item.moreUrl
      } else if (item.moreOpenType === 'newTab') {
        window.open(item.moreUrl)
      } else if (item.moreOpenType === 'frame') {
        // this.openMenu({
        //   value: item.moreFullUrl,
        //   key: 'name',
        //   url: item.moreFullUrl
        // })
        this.openMenuStatic({
          id: 'diy-portal',
          value: item.title || item.moreUrl,
          key: 'name',
          url: item.moreUrl
        })
      }
    },
    initEcharts () {
      let len = this.$refs.widgetRef ? this.$refs.widgetRef.length : 0
      for (let i = 0; i < len; i++) {
        this.$refs.widgetRef[i].chartsResize()
        this.$refs.widgetRef[i].imageResize()
      }
    }
  },
  mixins: [ErrorHandleMixin]
}
</script>

<style scoped lang="less" rel="stylesheet/less">
.page {
  overflow: hidden;
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  .m-warning-alert {
    // width: calc(~"100% - 32px");
    height: 32px;
    font-size: 12px;
    color: rgba(0, 0, 0, 0.7);
    line-height: 30px;
    padding: 0 0 16px;
    // margin: 16px auto 12px;
    box-sizing: border-box;
    border-radius: 2px;
    border: 1px solid rgba(254, 204, 0, 0.7);
    background: rgba(254, 204, 0, 0.08);
    i {
      display: block;
      float: left;
      color: #fecc00;
      font-size: 14px;
      margin-right: 10px;
      margin-top: 8px;
    }
    .u-btn-close {
      float: right;
      font-size: 24px;
      margin: 4px;
      color: rgba(0, 0, 0, 0.7);
      cursor: pointer;
    }
    /deep/ a {
      text-decoration: none !important;
      color: #2196f3 !important;
    }
  }
  .container {
    position: relative;
    width: 100%;
    height: 100%;
    overflow: hidden;
    background: #f5f5f5;
    .m-widget-box {
      width: 100%;
      height: calc(~"100% - 40px");
    }
    .u-parts-head {
      width: 100%;
      height: 40px;
      font-size: 14px;
      color: #4c4c4c;
      letter-spacing: 0;
      line-height: 40px;
      text-indent: 10px;
      box-sizing: border-box;
      .u-more {
        float: right;
        margin-right: 10px;
        font-size: 12px;
        color: #7f7f7f;
        text-decoration: none;
        cursor: pointer;
      }
    }
    /deep/ .m-scroll-wrap {
      position: absolute;
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
    }
  }
  .is-overdue {
    height: calc(~"100% - 34px");
  }
}
</style>
